import { render, staticRenderFns } from "./HomeAutomation.vue?vue&type=template&id=4c94707a&"
import script from "./HomeAutomation.vue?vue&type=script&lang=js&"
export * from "./HomeAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports